import type { RootState } from 'store'

export const getName = (state: RootState) =>
  state.exhibition?.values?.name ?? ''
export const getInitialName = (state: RootState) =>
  state.exhibition?.values?.initialName ?? ''
export const getNameChecking = (state: RootState) =>
  state.exhibition?.values?.nameChecking ?? ''
export const getDateStart = (state: RootState) =>
  state.exhibition?.values?.dateStart ?? ''
export const getDateEnd = (state: RootState) =>
  state.exhibition?.values?.dateEnd ?? ''
export const getCountry = (state: RootState) =>
  state.exhibition?.values?.country ?? ''
export const getPlace = (state: RootState) =>
  state.exhibition?.values?.place ?? ''
export const getWebsite = (state: RootState) =>
  state.exhibition?.values?.website ?? ''
export const getParticipantsMin = (state: RootState) =>
  state.exhibition?.values?.participantsMin ?? ''
export const getParticipantsMax = (state: RootState) =>
  state.exhibition?.values?.participantsMax ?? ''
export const getType = (state: RootState) =>
  state.exhibition?.values?.exhibitionType ?? ''
export const getNameError = (state: RootState) => state.exhibition?.errors?.name
export const getCountryError = (state: RootState) =>
  state.exhibition?.errors?.country
export const getWebsiteError = (state: RootState) =>
  state.exhibition?.errors?.website
